import useInputCheckout from "../../hooks/useInputCheckout";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import baseUrl from "../../url/baseUrl";
import { cartActions } from "../../store/cart-slice";

const CheckoutForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart.items);
  const totalPrice = useSelector((state) => state.cart.totalPrice);
  const isLogin = useSelector((state) => state.loginUser.isLogin);

  const initialUserData = JSON.parse(localStorage.getItem("currentUser")) || {};

  const {
    data: fullName,
    setData: setFullName,
    error: nameError,
  } = useInputCheckout(
    (input) => input.length > 3,
    initialUserData.username || ""
  );

  const {
    data: email,
    setData: setEmail,
    error: emailError,
  } = useInputCheckout(
    (input) => input.length > 0 && input.includes("@"),
    initialUserData.email || ""
  );

  const {
    data: phone,
    setData: setPhone,
    error: phoneError,
  } = useInputCheckout(
    (input) => input.length > 3 && !isNaN(input),
    initialUserData.phone || ""
  );

  const {
    data: address,
    setData: setAddress,
    error: addressError,
  } = useInputCheckout(
    (input) => input.length > 3,
    initialUserData.address || ""
  );

  const productListInfo = cart.map((prod) => {
    return {
      productId: prod.productId,
      sizeInfo: prod.sizeInfo,
      quantity: prod.quantity,
    };
  });

  const orderHandler = async (e) => {
    e.preventDefault();

    const order = {
      fullname: fullName,
      email: email,
      phone: phone,
      address: address,
      totalPrice: totalPrice,
      products: productListInfo,
      delivery: "Đợi giao hàng",
      status: "Đợi thanh toán",
      cartItems: cart,
    };

    if (isLogin) {
      try {
        const response = await fetch(baseUrl + "/checkout", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify(order),
        });

        if (response.status !== 201) {
          throw new Error("Cannot create order!");
        }
        // data tra ve tu server la thông tin user với cart items đã được làm rỗng sau khi order
        const data = await response.json();
        // update cart items rỗng này vào store redux
        dispatch(cartActions.updateCartItems(data.cart.items));
        alert("Order Successfully!");
        navigate("/products");
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        const response = await fetch(baseUrl + "/checkoutWithoutLogin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify(order),
        });

        if (response.status !== 201) {
          throw new Error("Cannot create order!");
        }
        // data tra ve tu server la thông tin user với cart items đã được làm rỗng sau khi order
        const data = await response.json();
        // update cart items rỗng này vào store redux
        dispatch(cartActions.updateCartItems(data.cart));
        // chuyển array trong localStorage thành []
        localStorage.setItem("unLogCart", JSON.stringify(data.cart));
        alert("Order Successfully!");
        navigate("/products");
      } catch (err) {
        console.log(err);
      }
    }
  };

  // function to setup disabled for reserve button
  const isFormInvalid = () => {
    return (
      !fullName ||
      nameError ||
      !email ||
      emailError ||
      !phone ||
      phoneError ||
      !address ||
      addressError
    );
  };

  return (
    <form className="Co_form_detail" onSubmit={orderHandler}>
      <div className="Co_input">
        <label className="Co_label">Tên:</label>
        <input
          type="text"
          name="fullName"
          value={fullName}
          placeholder="Enter Your Full Name Here!"
          onChange={(e) => setFullName(e.target.value)}
        />
        {nameError && (
          <p style={{ color: "red" }}>Tên phải nhiều hơn 3 ký tự!</p>
        )}
      </div>

      <div className="Co_input">
        <label className="Co_label">Email:</label>
        <input
          type="email"
          name="email"
          value={email}
          placeholder="Enter Your Email Here!"
          onChange={(e) => setEmail(e.target.value)}
        />
        {emailError && (
          <p style={{ color: "red" }}>Vui lòng điền 1 email hợp lệ.</p>
        )}
      </div>

      <div className="Co_input">
        <label className="Co_label">Điện thoại:</label>
        <input
          type="number"
          name="phone"
          value={phone}
          placeholder="Enter Your Phone Number Here!"
          onChange={(e) => setPhone(e.target.value)}
        />
        {phoneError && (
          <p style={{ color: "red" }}>
            Điện thoại phải dạng số và nhiều hơn 3 ký tự.
          </p>
        )}
      </div>

      <div className="Co_input">
        <label className="Co_label">Địa chỉ:</label>
        <input
          type="text"
          name="address"
          value={address}
          placeholder="Enter Your Address Here!"
          onChange={(e) => setAddress(e.target.value)}
        />
        {addressError && (
          <p style={{ color: "red" }}>Địa chỉ phải nhiều hơn 3 ký tự!</p>
        )}
      </div>

      <button
        type="submit"
        className={`${isFormInvalid() ? "disabled" : ""} `}
        disabled={isFormInvalid()}
      >
        Đặt hàng
      </button>
    </form>
  );
};

export default CheckoutForm;
